<template>
  <div class="tile is-parent">
    <article class="tile is-child box">
      <p class="title">标题--{{currentFashionMenu.moduleName}}</p>
      <div class="block">
        <input class="input width-3" v-model="params.title">
      </div>
      <p class="title">显示状态</p>
      <div class="block">
        <input type="radio" value="1" name="setStatus" v-model="params.status"><label>永久开启</label>
        <input type="radio" value="0" name="setStatus" v-model="params.status"><label>永久关闭</label>
        <input type="radio" value="2" name="setStatus" v-model="params.status"><label>定时开关</label>
      </div>
      <div class="block" v-if="params.status == 2">
        <el-date-picker v-model="timeRange" type="datetimerange" placeholder="选择时间范围"></el-date-picker>
      </div>
      <p class="title">自定义链接</p>
      <div class="block cyzs-w-400">
        <custom-link :link='params.ext.link' @update:link="val => {params.ext.link = val }"></custom-link>
      </div>
      <div class="block">
        <span class="button is-primary" id="js_imageUploadBtn" style="line-height: 30px;">上传图片</span>
        <span class="upload-img-tips">{{getUploadImgTips(currentFashionMenu.moduleName)}}</span>
      </div>
      <div class="block">
        <image-component :image='params.ext.image.image' :width='600'></image-component>
      </div>
      <div class="block">
        <button class="button is-primary" @click="saveEdit">保存</button>
        <button class="button" @click="backClick">返回</button>
      </div>
    </article>
  </div>
</template>
<script type="text/babel">
import Uploader from 'COMMON/uploaderModule/uploader'
import CustomLink from 'COMMON/DefinedLink'
import { mapState, mapActions } from 'vuex'
import { formatDate } from 'UTILS/date'

export default {
  components: {
    CustomLink
  },
  data () {
    return {
      checkLink: false, // 不启用自定义链接内部检查提示
      contentId: 0,
      timeRange: [],
      params: {
        type: this.$route.query.type,
        contentId: this.$route.query.contentId,
        moduleId: this.$route.query.moduleId,
        moduleType: 1,
        title: '',
        status: 0,
        ext: {
          image: {
            image: '',
            width: 0,
            height: 0
          },
          link: ''
        }
      }
    }
  },
  computed: {
    ...mapState({
      currentFashionMenu: state => state.currentFashionMenu
    })
  },
  mounted () {
    if (this.currentFashionMenu.moduleType == -1) {
      this.setCurrentFashionMenuByVuex({
        type: this.$route.query.type,
        moduleType: this.$route.query.moduleType,
        moduleId: this.$route.query.moduleId,
        moduleName: this.$route.query.moduleName
      })
    }
    if (this.params.status == 1 && this.params.endTime > 0) { // 定时开启的
      this.params.status = 2
    } else if (this.params.status == 1) { // 永久开启的
      this.params.status = 1
    } else { // 关闭
      this.params.status = 0
    }
    this.contentId = this.$route.query.contentId
    if (this.contentId > 0) {
      this.getContentInit()
    }
    this.uploadMainBind()
  },
  methods: {
    ...mapActions([
      'setCurrentFashionMenuByVuex'
    ]),
    /**
       * 获取内容详情
       * */
    getContentInit () {
      if (!this.contentId) {
        return
      }
      let params = {
        contentId: this.contentId
      }
      HttpRequest.get('/admin.php?method=fashion.getModuleContent', params, true).then((response) => {
        this.params = response.data
        if (response.data.endTime > 0 && response.data.status == 1) {
          this.params.status = 2
        } else {
          this.params.status = response.data.status
        }
        this.timeRange.push(formatDate(response.data.startTime, 'yyyy-MM-dd hh:mm:ss'))
        this.timeRange.push(formatDate(response.data.endTime, 'yyyy-MM-dd hh:mm:ss'))
      })
    },
    /**
       * 绑定图片上传
       * */
    uploadMainBind () {
      // 绑定上传图片控件
      let params = {
        config: {
          pick: {
            id: '#js_imageUploadBtn',
            multiple: false
          },
          server: process.env.VUE_APP_PLATFORM + '/admin.php?method=image.uploadImage',
          fileVal: 'image',
          fileSizeLimit: 1 * 1024 * 1024,
          fileSingleSizeLimit: 1 * 1024 * 1024
        },
        extensionField: {
          target: this
        },
        events: {
          onFilesQueued (files, uploaderObj) {
            return this.onFilesQueued && this.onFilesQueued(files, uploaderObj)
          },
          onSuccess (response, file, uploaderObj) {
            this.params.ext.image.image = response.data.images.info.path
            this.params.ext.image.width = response.data.images.info.width
            this.params.ext.image.height = response.data.images.info.height
          },
          onError (response, file, uploaderObj) {

          }
        }
      }
      new Uploader(params)
    },
    /**
       * 保存编辑
       * */
    saveEdit () {
      let params = Object.assign({}, this.params)
      params.ext = JSON.stringify(params.ext)
      params.startTime = this.timeRange[0]
      params.endTime = this.timeRange[1]
      params.contentId = this.contentId
      if (this.params.status == 2) {
        if (!params.startTime) {
          this.$message('请选择开始时间')
          return
        }
        if (!params.endTime) {
          this.$message('请选择结束时间')
          return
        }
      }
      if (this.params.status == 2) {
        params.status = 1
      } else {
        params.startTime = ''
        params.endTime = ''
        params.status = this.params.status
      }
      HttpRequest.post('/admin.php?method=fashion.doSaveModuleContent', params, true).then((response) => {
        this.$message('编辑成功')
        if (response.data.success == 1) {
          setTimeout(() => {
            // 返回列表
            if (this.$route.query.type == 1) {
              this.$router.push({
                name: 'discovery',
                query: {
                  page: this.$route.query.page
                }
              })
            } else {
              this.$router.push({
                name: 'market',
                query: {
                  page: this.$route.query.page
                }
              })
            }
          }, 2000)
        } else {
          this.$message('接口错误,请联系管理员')
        }
      }, (response) => {

      })
    },
    /**
       * 返回
       * */
    backClick () {
      if (this.$route.query.type == 1) {
        this.$router.push({
          name: 'discovery',
          query: {
            page: this.$route.query.page
          }
        })
      } else {
        this.$router.push({
          name: 'market',
          query: {
            page: this.$route.query.page
          }
        })
      }
    },
    getUploadImgTips (name) {
      let tips = ''
      switch (name) {
        case '当季热卖':
          tips = '建议尺寸:130*140px;(图片尺寸小于1M)'
          break
        case '好店推荐':
          tips = '建议尺寸:194*312px;(图片尺寸小于1M)'
          break
        case '明星精选':
          tips = '建议尺寸:220*170px;(图片尺寸小于1M)'
          break
        default:
          tips = '【当季热卖】建议尺寸:130*140px; 【好店推荐】建议尺寸:194*312px;【明星精选】建议尺寸:220*170px;(图片尺寸小于1M)'
      }
      return tips
    }
  }
}
</script>
<style lang="less">
  .custom-link-wrap{
    border-radius: 6px;
    border: 1px solid #00d1b2;
    width: 300px;
    padding: 20px;
  }
  .upload-img-tips{
    position: relative;
    top: 10px;
    color: #ff0000;
  }
</style>
